const cloudinaryInstance = cloudinary.Cloudinary.new({
  cloud_name: PetRescue.env.cloudinary.cloudName,
})

const cloudinaryDefaults = {
  cloudName: PetRescue.env.cloudinary.cloudName,
  uploadPreset: PetRescue.env.cloudinary.uploadPreset,
  styles:{
    palette: {
      windowBorder: "#90A0B3",
      tabIcon: "#5FA503",
      menuIcons: "#5A616A",
      link:  "#5FA503",
      action:  "#333333",
    }
  }
}

export default cloudinaryInstance

export function openCloudinaryWidget(options = {}) {
  const params = { ...options, ...cloudinaryDefaults }
  const results = []
  return new Promise((resolve, reject) => {
    cloudinary.openUploadWidget(params, function (error, result) {

      if (result.event == "success") {
        results.push(result)
      }

      if (result.event == "close") {
        resolve(results)
      }

      if (error) {
        console.error('Cloudinary widget failed to open', error)
        reject(error)
      }
    })
  })
}
